import { createFileRoute } from "@tanstack/react-router";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Button from "@/components/common/Buttons/Button";
import HomeScreenContent from "@/components/home/HomeScreenContent";
import { useCreateSession } from "@/hooks/useCreateSession";
import useNavigationHelpers from "@/hooks/useNavigationHelpers";
import { useStore } from "@/store";

export const Route = createFileRoute("/$locale/$partner/_app/")({
	component: Home,
});

function Home() {
	const hasSecurePin = useStore((s) => s.config?.pagesConfig?.home?.hasSecurePin);
	const { suppressHome, goToNextStep } = useNavigationHelpers();

	if (suppressHome) {
		return null;
	}

	return (
		<HomeContent
			hasSecurePin={!!hasSecurePin}
			onSessionCreated={goToNextStep}
		/>
	);
}

type HomeContentProps = {
	hasSecurePin: boolean;
	onSessionCreated: () => void;
};

function HomeContent({ hasSecurePin, onSessionCreated }: HomeContentProps) {
	const { t, i18n } = useTranslation();
	const { getSessionId, loading, securePinElement } = useCreateSession(hasSecurePin, onSessionCreated);

	useEffect(() => {
		i18n.reloadResources();
	}, [i18n]);

	return (
		<AnimatePresence>
			<motion.div
				key={0}
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				exit={{ opacity: 0 }}
				transition={{ duration: 0.5 }}
				className="flex-1 h-full"
			>
				<div style={{ height: "calc(100% - 64px)" }}>
					<HomeScreenContent />
					{securePinElement}
					<div className="w-full flex justify-center my-8">
						<Button
							size="large"
							label={t("btn.Start now")}
							onClick={() => getSessionId()}
							loader={loading}
							disabled={loading}
						/>
					</div>
				</div>
			</motion.div>
		</AnimatePresence>
	);
}
